<template>
  <!-- ball 步骤条 -->
  <div class="wms-ball-steps">
    <div class="wms-ball-steps-content" v-for="item in balls">
      <div
        :style="{left: item.style.ballLeft+'px',top:item.style.ballTop+'px',width:item.style.ballWidth + 'px',height:item.style.ballHeight + 'px'}"
        class="wms-ball-steps-content-ball"
      >
        <div class="wms-ball-steps-content-ball-title">{{item.data.title}}</div>
        <div class="wms-ball-steps-content-ball-content">{{item.data.number}}</div>
      </div>
      <div
        :style="{left: item.style.lineLeft+'px',top:item.style.lineTop+'px',width:item.style.lineWidth + 'px',height:item.style.lineHeight + 'px'}"
        class="wms-ball-steps-content-line"
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WMSBallStep',
    props: {
      steps: {
        type: Array,
        default() {
          return []
        }
      },
      ballWH: {
        type: Number,
        default() {
          return 0.3
        }
      },
      margin: {
        type: Number,
        default() {
          return 0.13
        }
      }
    },
    data() {
      return {
        balls: []
      }
    },
    mounted() {
      this.refresh()
    },
    watch: {
      steps: function(val) {
        this.refresh()
      }
    },
    methods: {
      refresh: function() {
        this.balls = []
        let contentHeight = this.$el.clientHeight
        let contentWidth = this.$el.clientWidth
        let ballHeight = contentWidth * this.ballWH
        let marginH = contentWidth * this.margin
        let marginV =
          (contentHeight - ballHeight * (Math.floor(this.steps.length / 2) + 1)) /
          (Math.floor(this.steps.length / 2) + 2)
        let lineWidth = contentWidth - marginH * 2 - ballHeight * 1.5
        for (let i = 0; i < this.steps.length; i++) {
          let item = {
            data: {
              title: this.steps[i].title,
              number: this.steps[i].number
            },
            style: {
              ballLeft: 0,
              ballTop: 0,
              ballWidth: 0,
              ballHeight: 0,
              lineLeft: 0,
              lineTop: 0,
              lineWidth: 0,
              lineHeight: 0
            }
          }
          if (i % 2 === 0) {
            item.style.ballLeft = marginH
            item.style.ballTop = (i / 2 + 1) * marginV + (i / 2) * ballHeight
            item.style.ballWidth = ballHeight
            item.style.ballHeight = ballHeight
            item.style.lineLeft = marginH + ballHeight
            item.style.lineTop = item.style.ballTop + 0.5 * ballHeight
            item.style.lineHeight = marginV * 0.5
            item.style.lineWidth = lineWidth
          } else {
            item.style.ballLeft = contentWidth - marginH - ballHeight
            item.style.ballTop = (i / 2 + 1) * marginV + (i / 2) * ballHeight
            item.style.ballWidth = ballHeight
            item.style.ballHeight = ballHeight
            item.style.lineLeft = marginH + ballHeight * 0.5
            item.style.lineTop = item.style.ballTop + 0.5 * ballHeight
            item.style.lineHeight = marginV * 0.5
            item.style.lineWidth = lineWidth
          }
          this.balls.push(item)
        }
      }
    }
  }
</script>

<style scoped>
  .wms-ball-steps {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .wms-ball-steps-content-ball {
    position: absolute;
    background-color: #eee;
    border-radius: 50%;
  }

  .wms-ball-steps-content-ball-title {
    font-size: 14px;
    height: 50%;
    text-align: center;
    padding-top: 20px;
  }

  .wms-ball-steps-content-ball-content {
    height: 50%;
    text-align: center;
  }

  .wms-ball-steps-content-line {
    position: absolute;
    border-top: 2px solid #eee;
  }

  .wms-ball-steps-content:nth-child(odd) .wms-ball-steps-content-line {
    border-right: 2px solid #eee;
  }

  .wms-ball-steps-content:nth-child(even) .wms-ball-steps-content-line {
    border-left: 2px solid #eee;
  }

  .wms-ball-steps-content:last-child .wms-ball-steps-content-line {
    border: none;
    border-color: red;
  }
</style>